module.exports = __webpack_public_path__ + "img/SoftwareCopyright_14.69bd17cb.png";